import React from "react";
import produce from "immer";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { IconButton, TextField } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { EyeService } from "../../../interfaces/AssessmentInterfaces";

interface PropType {
  services: Array<EyeService>;
  item: EyeService;
  index: number;
  handleRemoveService: (i: Array<EyeService>) => void;
  handleUpdateService: (v: EyeService) => void;
}

function EyeServicesRow({
  item,
  services,
  handleRemoveService,
  handleUpdateService,
  index
}: PropType): React.JSX.Element {
  const [note, setNote] = React.useState<string>(item?.note || "");

  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell>{index + 1}.</TableCell>
      <TableCell>{item.name}</TableCell>
      <TableCell>
        <TextField
          value={note}
          placeholder="Note"
          onChange={(event) => setNote(event.target.value)}
          onBlur={() => handleUpdateService({ ...item, note })}
          variant="outlined"
          sx={{ width: "100%" }}
        />
      </TableCell>
      <TableCell sx={{ textAlign: "right" }}>
        <IconButton
          color="error"
          onClick={() => {
            const mutatedServices = produce(services, (draft) => {
              draft.splice(index, 1);
            });
            handleRemoveService(mutatedServices);
          }}
          size="small"
        >
          <DeleteForeverIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

export default EyeServicesRow;
